import { useFragmentsViewCapture } from '@app/modules/fragments/hooks/useFragmentsViewCapture';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { lighten } from 'polished';
import { defineMessage, useIntl } from 'react-intl';
import { useTranscriptionInteractionsStore } from '../hooks/useTranscriptionInteractionsStore';

const searchTooltipOnMessage = defineMessage({
  id: 'fragments.transcription.v2.searchTooltipOn',
  defaultMessage: 'Buscar: activado',
});

const searchTooltipOffMessage = defineMessage({
  id: 'fragments.transcription.v2.searchTooltipOff',
  defaultMessage: 'Buscar: desactivado',
});

/**
 * Toggles visibility of the transcript search field below the panel header.
 * Captures open/close as `fragments_view:transcription_search_toggle`.
 */
export function TranscriptionSearchToggleAction() {
  const theme = useTheme();
  const { $t } = useIntl();
  const fragmentsCapture = useFragmentsViewCapture();
  const isSearchOpen = useTranscriptionInteractionsStore((state) => state.isSearchOpen);
  const setIsSearchOpen = useTranscriptionInteractionsStore((state) => state.setIsSearchOpen);

  const searchIconButton = (
    <IconButton
      size="small"
      color={isSearchOpen ? 'success' : 'secondary'}
      sx={{
        bgcolor: isSearchOpen ? lighten(0.45, theme.palette.success.light) : undefined,
      }}
      onClick={() => {
        const nextEnabled = !isSearchOpen;
        fragmentsCapture.transcriptionSearchToggle({ enabled: nextEnabled });
        setIsSearchOpen(nextEnabled);
      }}
    >
      <SearchIcon fontSize="small" />
    </IconButton>
  );

  return (
    <Tooltip
      placement="top"
      title={isSearchOpen ? $t(searchTooltipOnMessage) : $t(searchTooltipOffMessage)}
    >
      {searchIconButton}
    </Tooltip>
  );
}
